
import {Component, Prop, Vue, Watch} from "vue-property-decorator";
import InnerImageZoom from "./custom-vue-inner-image-zoom.js";

@Component({
  components: {
    InnerImageZoom
  },
})
export default class ImageZoomModal extends Vue {
  @Prop()
  public show: boolean;

  @Prop()
  public src: string;

  @Prop()
  public alt: string;

  @Prop()
  public zoomable: boolean;

  @Prop()
  public zoomScale: number;

  private modalOpen: boolean = false;
  private opening: boolean = false;
  private zoomActive: boolean = false;

  private get componentClasses(): string {
    const classes = ["image-zoom-modal"];

    if (this.zoomActive) {
      classes.push("zoom-active");
    }

    return classes.join(" ");
  }

  private onClickOutside() {
    if (!this.opening) {
      this.modalOpen = false;
    }
  }

  private afterZoomIn() {
    this.zoomActive = true
  }

  private afterZoomOut() {
    this.zoomActive = false
  }

  @Watch("show")
  private onShowUpdate(value: boolean) {
    if (value) {
      this.modalOpen = true;
      this.opening  = true;

      setTimeout(() => {
        this.opening = false;
      }, 500);
    }
  }

}
